import {useMutation} from "@tanstack/react-query";
import {SalesSearchParamType} from "../interface";
import moment from "moment";
import {downloadFile} from "../../../../../util/FileDownload";
import {exportYearlyRevenueExcel} from "../../../../../api/main/SalesApi";
import {AxiosError} from "axios";
import {useModal} from "../../../../../hooks";

export const useExportYearlyRevenueExcel = () => {
    const {handleModal} = useModal();

    const {mutate} = useMutation({
        mutationFn: (data: SalesSearchParamType) => exportYearlyRevenueExcel(data),
        onSuccess: (res, variables) => {
            if (res instanceof Blob) {
                const now = moment().format("YYYY_MM_DD_hh_mm")

                downloadFile(res, `연간_매출_목록_${now}.xlsx`)
            }
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            handleModal({
                isOpen: true,
                contents: "엑셀파일작성처리하는 도중, 서버오류가 발생하였습니다.",
                type: "alert",
            });
        },
    });

    return {mutate};
};
